export default __webpack_public_path__ + "maps-examples-custom-style-1200-91afa501a59a788628292be2cc372d7f.png";